import { render } from "./Bar.vue?vue&type=template&id=517fd311&scoped=true"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"

import "./Bar.vue?vue&type=style&index=0&id=517fd311&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517fd311"]])

export default __exports__